import {RefObject, useEffect} from 'react';

export const useTrackUIMutation = (
    containerRef: RefObject<HTMLElement | null>,
    onChange: (changes: MutationRecord) => void,
    options: MutationObserverInit = {attributes: true},
) => {
    useEffect(() => {
        const observer = new MutationObserver(([mutation]) =>
            onChange(mutation),
        );
        observer.observe(containerRef.current!, options);
        return () => {
            observer.disconnect();
        };
    }, [containerRef, onChange]);
};
